import React, { useState, useCallback, useMemo } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import UnbookedImsBanner from "@/components/UnbookedImsBanner";
import AIAssistantPanel from "@/components/AIAssistantPanel";
import FloatingHelpButton from "@/components/FloatingHelpButton";
import GuideCaptureFloater from "@/components/GuideCaptureFloater";
import { Toaster } from "sonner";

export default function AppLayout() {
  const [aiOpen, setAiOpen] = useState(false);
  const openAI = useCallback(() => setAiOpen(true), []);
  const ctx = useMemo(() => ({ openAI }), [openAI]);
  return (
    <div className="flex h-screen bg-background text-foreground">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <AnnouncementBanner />
        <Topbar onOpenAI={openAI} />
        <UnbookedImsBanner />
        <main className="flex-1 overflow-y-auto">
          <Outlet context={ctx} />
        </main>
      </div>
      <AIAssistantPanel open={aiOpen} onOpenChange={setAiOpen} />
      <FloatingHelpButton />
      <GuideCaptureFloater />
      <Toaster theme="light" position="top-right" richColors />
    </div>
  );
}
